import Dialog from './Dialog.js'


/**
 * 同步用法
 * @param {String} title 提示
 * @param {String} message 内容
 * @param {Boolean} showCancelButton 是否展示取消按钮 default:false
 * @param {Boolean} showConfirmButton 是否展示确认按钮 default:false
 * @param {Boolean} closeOnClickOverlay 是否在点击遮罩层后关闭弹窗 default: false
 * @param {Number} duration 关闭时间 showCancelButton为false && showConfirmButton为false时 default:2000
 * @param {String} cancelButtonText 取消btn文案
 * @param {String} confirmButtonText 确认btn文案
 * 
 * 注意！！！ 由于vantUI 组件左btn为取消，由btn为确认，与项目设计稿相反，故cancel event为Confirm 事件!!!
 */
function ModalSync(options) {
  return new Promise((resolve, reject) => {
    Modal({
      ...options,
      onClose(action) {
        if (action === "confirm") resolve(action);
        else reject(action);
      },
    });
  });
}

/**
 * 封装Vant Dialog
 */
const Modal = function(Vue) {
  Vue.prototype.$Modal = Dialog;
  Vue.prototype.$ModalSync = ModalSync;
};

export default Modal


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js